import { createSelector } from 'reselect'

import { currentInviteeSelector } from 'selectors/current_invitee'

const publisherSelector = (state) => {
  if (Object.keys(state.scheduling.event).length !== 0) {
    return state.scheduling.event.scheduled_profile
  }
  if (currentInviteeSelector(state) && (Object.keys(currentInviteeSelector(state)).length !== 0)) {
    return currentInviteeSelector(state)
  }
  return {}
}

export const emailSelector = createSelector(
  publisherSelector,
  ({ email }) => email
)
